export default __webpack_public_path__ + "static/media/angelus-block-co.ec68fce0.png";